const translations = {
  'header': {
    'main': 'Асоси',
    'vozm': 'Имкониятҳо',
    'products': 'Продуктхо',
    'docs': 'Ҳуҷҷатгузорӣ',
    'request': 'Дархостро ирсол намоед',
  },
  'mainPage': {
    'title': 'Бонк дар як телефон!',
    'desc': 'Молияи худро ба осонӣ ва қулай назорат кунед!',
    'request': 'Дархостро ирсол намоед',
  },
  'vozm': {
    'mainTitle': 'Имкониятҳои Ориён Бизнес',
    'title1': 'Тасдиқи осони пардохтҳо бо СМС-паёмак',
    'title3': 'Дар ҳама гуна дастгоҳҳо фаъолият менамояд',
  },
  'products': {
    'mainTitle': 'Маҳсулот барои тиҷорати шумо',
    'title2': 'Эквайринги тиҷоратӣ',
    'title3': 'Лоиҳаи музди меҳнат',
    'title4': 'Хизматрасониҳои ҳисоббаробаркунӣ-хазинавӣ',
  },
  'documents': {
    'mainTitle': 'Ҳуҷҷатҳо',
    'title1': 'Нархҳо',
  },
  'footer': {
    'forClients': {
      'title': 'Барои муштариён',
    },
    'aboutBank': {
      'title': 'Дар бораи бонк',
    },
    'products': {
      'title': 'Маҳсулот',
    },
    'contacts': {
      'title': 'Робита',
      'address': 'ш.Душанбе, Рӯдакӣ, 95/1',
    },
  },
  'RECEIVED': 'Қабул шуд',
  'IN_PROGRESS': ' Коркард мешавад',
  'IN_VERIFICATION': 'Тасдиқ тариқи СМС',
  'IN_CONFIRMATION': 'Дар интизори тасдиқ',
  'READY': 'Омода шуд',
  'SUCCESS': 'Муваффақ',
  'FAILED': 'Номуваффақ',
  'DECLINED': 'Рад карда шуд',
  'INVALID_FILE': 'Ҳуҷҷати нодуруст',
  'INVALID': 'Нодуруст',
  'IN_APPROVAL': 'Дар ҳоли тасдиқшавӣ',
  'TO_APPROVE': 'Барои тасдиқ',
  'APPROVED': 'Тасдиқ шуд',
  'PARTIAL_SUCCESS': 'Қисман иҷро шуд',
  'POSTPONED': 'Ба таъхир гузошта шуд',
  'IN_BANK_REVIEW': 'Дар баррасии бонк',
  'IN_REVIEW': 'Дар баррасӣ',
  'BANK_APPROVED': 'Аз тарафи бонк тасдиқ шуд',
  'CANCELED': 'Рад шуд',
  'BANK_DECLINED': 'Бонк рад кард',
  'REVERSED': 'Баргардонида шуд',
  'IN_VALIDATION': 'Дар ҳоли тафтиш',
  'READY_TO_PROCEED': 'Омода барои гузаронидан',
  'Language': 'Тоҷикӣ',
  'Transactions': 'Амалиёт',
  'Accounts': 'Суратҳисобҳо',
  'Filter': 'Филтр',
  'Status': 'Ҳолат',
  'Find': 'Ҷустуҷӯ',
  'ID': 'ID',
  'Name': 'Ном',
  'Phone number': 'Рақами телефони мобилӣ',
  'Intrabank': 'Дохилибонкӣ',
  'Salaries': 'Маошҳо',
  'Interbank': 'Байнибонкӣ',
  'Interbank payment': 'Амалиёти Байнибонкӣ',
  'SWIFT': 'СВИФТ',
  'Ruble': 'Рубли русӣ',
  'Account': 'Суратҳисоб',
  'Search': 'Ҷустуҷӯ',
  'All': 'Ҳама',
  'Sign in': 'Воридшавӣ ба система',
  'Signing in': 'Дар ҳоли тасдиқшавӣ',
  'Processing': 'Коркард мешавад',
  'Not successful': 'Номуваффақ',
  'Successful': 'Муваффақ',
  'Date': 'Сана',
  'Sender': 'Ирсолкунанда',
  'Recipient': 'Қабулкунанда',
  'Sender account': 'Суратҳисоби ирсолкунанда',
  'Recipient account': 'Суратҳисоби қабулкунанда',
  'Transaction type': 'Навъи амалиёт',
  'Amount': 'Маблағ',
  'Login': 'Логин',
  'Password': 'Рамз',
  'Sign up': 'Бақайдгирӣ',
  'Exchange Rates': 'Қурби асъор',
  'NBT': 'БМТ',
  'Currency': 'Асъор',
  'Purchase': 'Харид',
  'Sale': 'Фурӯш',
  'USD': 'USD',
  'EUR': 'EUR',
  'RUB': 'RUB',
  'All accounts': 'Ҳамаи суратҳисобҳо',
  'TJS': 'TJS',
  'Last operations': 'Амалиётҳои охирин',
  'Between own accounts': 'Байни суратҳисобҳои худ',
  'Intrabank payment': 'Пардохти дохилибонкӣ',
  'MyAccounts': 'Суратҳисобҳои ман',
  'Active': 'Фаъол',
  'Not active': 'Ғайрифаъол',
  'Update': 'Навсозӣ',
  'Updated': 'Навсозишуда',
  'Russian': 'Русӣ',
  'English': 'Англисӣ',
  'Tajik': 'Тоҷикӣ',
  'Bank accounts': 'Суратҳисобҳои бонкӣ',
  'Visa Business': 'Visa Business',
  'Payment Information': 'Маълумоти пардохт',
  'Account Information': 'Маълумот оиди суратҳисоб',
  'File information': 'Маълумот оиди файл',
  'Account name': 'Номи суратҳисоб',
  'Balance': 'Тавозун',
  'Account type': 'Навъи суратҳисоб',
  'Address': 'Суроға',
  'TIN': 'РМА',
  'Date of opening': 'Санаи кушодашавӣ',
  'Requisites': 'Маълумоти муфассал',
  'Download': 'Зеркашӣ',
  'Upload': 'Боркуни',
  'Upload file': 'Боркуни файлҳо',
  'Description': 'Тавсиф',
  'Show filters': 'Намоишдиҳӣ филтрҳо',
  'No transaction': 'Амалиёт нест',
  'TxID': 'ID амалиёт',
  'Commission': 'Комиссия',
  'Commission amount': 'Маблағи комиссия',
  'Commission km': 'Комиссияҳо бо Корти миллӣ',
  'Commission visa': 'Комиссияҳо бо Visa',
  'Company information': 'Маълумоти ширкат',
  'Date of creation': 'Санаи ташкилебӣ',
  'Retry payment': 'Такрори пардохт',
  'Download PDF': 'Зеркашии PDF',
  'Authorizers': 'Ваколатдорон',
  'Reject': 'Рад кардан',
  'Confirm': 'Тасдиқ кардан',
  'Payment information': 'Маълумот оиди пардохт',
  'Bank information': 'Маълумот оиди бонк',
  'From account': 'Аз суратҳисоб',
  'To account': 'Ба суратҳисоб',
  'Transfer amount': 'Маблағи интиқол',
  'Narrative': 'Таъинот',
  'Existing template': 'Намунаи мавҷудбуда',
  'Sender information': 'Маълумот оиди ирсолкунанда',
  'Recipient information': 'Маълумот оиди қабулкунанда',
  'Account number': 'Рақами суратҳисоб',
  'Confirm account number': 'Тасдиқи рақами суратҳисоб',
  'Payment details': 'Тафсилоти пардохт',
  'Other details': 'Тафсилоти дигар',
  'Document type': 'Навъи ҳуҷҷат',
  'Document number': 'Рақами ҳуҷҷат',
  'Document date': 'Санаи ҳуҷҷат',
  'Save template': 'Сабти намуна',
  'Country': 'Мамлакат',
  'City': 'Шаҳр',
  'Enter amount': 'Маблағро ворид намоед',
  'Document': 'Ҳуҷҷат',
  'Enter document number': 'Рақами ҳуҷҷатро ворид намоед',
  'Initiator': 'Қабулкунанда',
  'Number of transactions': 'Миқдори амалиёт',
  'Import': 'Воридот',
  'Rejected': 'Рад карда шуд',
  'Importing payments from a file': 'Воридсозии пардохтҳо аз файл',
  'Download document': 'Зеркашии ҳуҷҷат',
  'Salary project': 'Лоиҳаи музди меҳнат',
  'Select account': 'Интихоби суратҳисоб',
  'Select date': 'Интихоби сана',
  'Order an statement': 'Фармоишдиҳии иқтибос',
  'View orders': 'Намоишдиҳӣ фармоишҳо',
  'Ordering a statement': 'Фармоиши иқтибос',
  'Enter the title': 'Сарлавҳаро ворид кунед',
  'Order': 'Фармоиш додан',
  'Orders': 'Фармоишҳо',
  'Ready': 'Омода',
  'In progress': 'Коркард',
  'Failed': 'Но муваффақ',
  'Period': 'Давра',
  'Tariffs': 'Тарофаҳо',
  'Transfer between own accounts': 'Интиқоли маблағ байни суратҳисобҳои шахсӣ',
  'Show all currencies': 'Намоишдиҳӣ ҳамаи асъор',
  'Rate': 'Қурб',
  'Currency сode': 'Рамзи асъор',
  'Unit': 'Воҳиди андозагирӣ',
  'Currency name': 'Номгуӣ асъор',
  'No.': '№',
  'Change Password': 'Иваз кардани рамз',
  'Log out': 'Баромадан',
  'Profile': 'Профил',
  'Enter a new password': 'Рамзи навро ворид намоед',
  'Enter old password': 'Рамзи куҳнаро ворид намоед',
  'Change': 'Иваз кардан',
  'Contacts': 'Тамос',
  'oriyon-business@oriyonbonk.tj': 'oriyon-business@oriyonbonk.tj',
  'Call center 2222': 'Маркази тамос 2222',
  'Loans': 'Қарзҳо',
  'Deposits': 'Пасандозҳо',
  'OtpCode': 'Рамзи тасдиқ',
  'ResendTime': 'Интиқоли дубора тавассути',
  'Second': 'сония',
  'ResendCode': 'Рамзро бори дигар фиристодан',
  'Save': 'Сабт',
  'All operations': 'Ҳамаи амалиётҳо',
  'Operation': 'Амалиёт',
  'No Transactions': 'Амалиёт нест',
  'Payments': 'Пардохтҳо',
  'More': 'Бештар',
  'Notifications': 'Огоҳиномаҳо',
  'No notifications': 'Огоҳинома нест',
  'New': 'нав',
  'CurrienciesToSomoni': 'Қурби расмии асъор нисбат ба сомонӣ',
  'Hide all currencies': 'Пинҳони асъор',
  'ToSign': 'Тасдиқ кунед',
  'Rejecteds': 'Рад кардашудаҳо',
  'Enter Recipient Account': 'Суратҳисоби қабулкунандаро ворид намоед',
  'Confirm payment': 'Тасдиқи пардохт',
  'Payment type': 'Намуди амалиёт',
  'Enter Recipient': 'Қабулкунандаро ворид намоед',
  'Enter TIN': 'РМА-ро ворид намоед',
  'Enter template name': 'Номи намуна-ро ворид намоед',
  'Recipient TIN': 'РМА-и қабулкунанда',
  'Show balance': 'Намоишдиҳӣ баланс',
  'Hide balance': 'Пинҳони баланс',
  'Hide filters': 'Пинҳони филтрҳо',
  'Swift': 'СВИФТ',
  'Bank name': 'Номи бонк',
  'Filters': 'Филтрҳо',
  'Show': 'Намоишдиҳӣ',
  'Select template': 'Шаблонро интихоб кунед',
  'One Dollar': '1 Доллар',
  'One Ruble': '1 Рубл',
  'One Euro': '1 Евро',
  'Orienbank Address': 'ш.Душанбе, Рудаки, 95/1',
  'Enter City': 'Шаҳро ворид намоед',
  'Enter Country': 'Мамлакатро ворид намоед',
  'Enter Address': 'Суроғаро ворид намоед',
  'Enter Account': 'Суратҳисобро ворид намоед',
  'Enter swift code': 'Свифт кодро ворид намоед',
  'Enter bank name': 'Номи бонкро ворид намоед',
  'Enter doc number': 'Рақами документро ворид намоед',
  'Enter SMS code': 'СМС-ро ворид намоед',
  'Find swift code': 'Ҷустучӯи свифт код',
  'Find bic code': 'Ҷустучӯи БИК код',
  'Required': 'Ҳатми',
  'Enter symbol only': 'Танҳо аломатҳоро ворид кунед',
  'Amount must be more 1': 'Маблағ бояд аз 1 зиёд бошад',
  'Wrong amount': 'Маблағи нодуруст',
  'Wrong type': 'Навъи нодуруст',
  'Latin Only': 'Танҳо ҳарфҳои лотиниро ворид кунед',
  'Account does not match': 'Суратҳисоби воридкардаи шумо мувофиқат намекунад!',
  'Account must contain no more than 20 digits': 'Суратҳисоб набояд аз 20 рақам зиёд бошад',
  'Account must contain no more than 21 digits': 'Суратҳисоб набояд аз 21 рақам зиёд бошад',
  'Account must contain no more than 35 digits': 'Суратҳисоб набояд аз 35 рақам зиёд бошад',
  'Account must contain at least 7 digits': 'Суратҳисоб бояд ҳадди аққал 7 рақам дошта бошад',
  'Account must contain at least 6 digits': 'Суратҳисоб бояд ҳадди аққал 6 рақам дошта бошад',
  'Account must contain at least 20 digits': 'Суратҳисоб бояд ҳадди аққал 20 рақам дошта бошад',
  'Enter number only': 'Танҳо рақамҳоро ворид кунед',
  'ConfirmSmsFromPhone': 'Барои тасдиқи транзаксия ба рақами телефони шумо коди SMS фиристода шуд',
  'No accounts': 'Суратҳисоб нест',
  'Account does not found': 'Суратҳисоб пайдо нашуд',
  'Must be 9 numbers': 'Бояд 9 рақам бошад',
  'Field must contain at least 8 digits': 'Майдон бояд на камтар аз 8 рақам дошта бошад!',
  'For registration':
    'Барои сабти ном дар системаи Интернет-банкинг ба идораи марказии Ориёнбонк, суроғаи рақамӣ муроҷиат намоед',
  'For any questions':
    'Барои ҳама гуна саволҳо лутфан ба маркази тамоси мо муроҷиат кунед, мо бо омодагӣ ба шумо кӯмак хоҳем кард',
  'Code': 'Код',
  'Sent code to phone for sequirity':
    'Барои бехатарӣ профили шумо, мо ба рақами телефони шумо рамзи тасдиқро мефиристем',
  'Sent code to email for sequirity': 'Барои бехатарӣ профили шумо, мо ба почтаи шумо рамзи тасдиқро мефиристем',
  'Google auth otp description':
    'Шумо тасдиқи дуқадама тавассути Google Authenticator фаъол кардед. Рамзи 6-рақамаро аз барнома ворид кунед.',
  'Change your password': 'Рамзи худро иваз кунед',
  'Password does not match': 'Пароли воридкардаи шумо мувофиқат намекунад!',
  'Confirm password': 'Паролро тасдиқ кунед',
  'Change and remind password': 'Рамзро ивазкунед ва ёдоварӣ намоед.',
  'International': 'Байналмилалӣ',
  'International tjs': 'Свифт бо сомони',
  'File date': 'Санаи файл',
  'Total amount': 'Маблағи умумй',
  'Debit': 'Дебет',
  'Credit': 'Кредит',
  'Own accounts payments': 'Амалиётиҳои байни суратҳисобҳо',
  'Intrabank payments': 'Амалиётиҳои дохилибонкӣ',
  'Interbank payments': 'Амалиётиҳои байнибонкӣ',
  'Successful count': 'Шумораи муваффақ',
  'Not successful count': 'Шумораи номуваффақ',
  'Download file': 'Зеркашии файл',
  'Error': 'Хатогиҳо',
  'Transaction list': 'Рӯйхат амалиётиҳо',
  'Branch': 'Филиал',
  'Card accounts': 'Суратҳисобҳои корти',
  'Approved': 'Тасдиқ кард',
  'From amount': 'Маблағ аз',
  'To amount': 'Маблағ то',
  'Start date': 'Саршавии сана',
  'End date': 'Тамомшавии сана',
  'Start period': 'Саршавии давра',
  'End period': 'Тамомшавии давра',
  'No data': 'Маълумот нест',
  'Enter document type': 'Намуди документро ворид намоед',
  'In confirmation': 'Интизори тасдиқ',
  'In verification': 'Дар иҷозат',
  'Partial success': 'Қисман иҷро шудаҳо',
  'Download salary file template': 'Зеркашии намунаи файли музди меҳнат',
  'Upload document': 'Ҳуҷҷатро Зеркашӣ кунед',
  'The file format must be xlsx, xls': 'Формати файл бояд xlsx, xls бошад',
  'The file format must be txt': 'Формати файл бояд txt бошад',
  'The file size should not exceed 2MB': 'Андозаи файл набояд аз 2 МБ зиёд бошад',
  'Wrong file format': 'Формати файл нодуруст аст',
  'FIO': 'Номи пурра',
  'Company name': 'Номи ширкат',
  'International payment': 'Пардохти байналмилалӣ',
  'Transaction date': 'Санаи пардохт',
  'Back': 'Баргаштан',
  'Repeat': 'Бори дигар',
  'Urgent': 'Таъҷилӣ',
  'Edit account name': 'Номи суратҳисобро таҳрир кунед',
  'Maximum number of characters: 70': 'Шумораи максималии аломатҳо: 70',
  'Confirm new password': 'Рамзи нави худро тасдиқ кунед',
  'Exit': 'Баромадан',
  'Pick': 'Интихоб',
  'Enter number or letter only': 'Танҳо рақам ва ҳарф ворид кунед',
  'Sure to confirm?': 'Шумо мутмаин ҳастед, ки мехоҳед тасдиқ кунед?',
  'Sure to decline?': 'Шумо мутмаин ҳастед, ки мехоҳед бекор кунед?',
  'Cancel': 'Бекор кардан',
  'Make a payment': 'Гузарондани амалиёт',
  'Enter': 'Воридшавӣ',
  'Insufficient funds in the account': 'Маблағи суратҳисоб кифоя нест',
  'Templates': 'Намунаҳо',
  'Internal': 'Дохилибонкӣ',
  'Delete': 'Тоза кардан',
  'BIC': 'БИК',
  'No Templates': 'Намунаҳо нестанд',
  'Statement': 'Иқтибос',
  'Exchange': 'Мубодилаи асъор',
  'Credit amount': 'Маблағи гирифташуда',
  'Debit amount': 'Маблағи воридшаванда',
  'Beneficiary Bank': 'Бонки қабулкунанда',
  'Print': 'Чоп кардан',
  'View all': 'Намоиши кул',
  'otpType': 'Лутфан усули гирифтани рамзи тасдиқро интихоб намоед',
  'withSMS': 'Ба воситаи СМС',
  'withEmail': 'Ба воситаи почтаи электрониӣ',
  'Email': 'Почта',
  'Recipient country': 'Мамлакати қабулкунанда',
  'Recipient city': 'Шаҳри қабулкунанда',
  'Recipient address': 'Адреси қабулкунанда',
  'Recipient bank address': 'Адреси бонки қабулкунанда',
  'Recipient bank name': 'Номи бонки қабулкунанда',
  'Recipient country name': 'Давлати бонки қабулкунанда',
  'Recipient bank swift': 'Swift коди бонки қабулкунанда',
  'onlyTwoMonths': 'На зиед аз ду моҳ',
  'Oriyon': 'Ориён',
  'Business': 'Бизнес',
  'Account Balances': 'Тавозуни суратҳисобҳо',
  'Account Balances in somoni': 'Тавозуни суратҳисобҳо бо сомонӣ',
  'Account Balances in dollars': 'Тавозуни суратҳисобҳо бо доллари ИМА',
  'Account Balances in euro': 'Тавозуни суратҳисобҳо бо Евро',
  'Account Balances in ruble': 'Тавозуни суратҳисобҳо бо Рубл',
  'Account Balances in riyal': 'Тавозуни суратҳисобҳо бо риол',
  'Account Balances in yuan': 'Тавозуни суратҳисобҳо бо юан',
  'Select format': 'Форматро интихоб намоед',
  'Format': 'Формат',
  'Enter bic code': 'БИК-ро интихоб намоед',
  'Ruble transfer': 'Интиқоли рублӣ',
  'EditionalInfo': 'Маълумоти Иловагӣ',
  'PrepaymentForProduct': 'Пешпардохти мол',
  'PaymentForProduct': 'Оплата за товар',
  'PrepaymentForService': 'Пардохти мол',
  'PaymentForService': 'Пардохт барои хидматҳо',
  'Others': 'Дигар',
  'Enter KPP': 'КПП-ро ворид намоед',
  'Correspondent account': 'Суратҳисобҳи корреспондентӣ',
  'Select narrative': 'Таъинот интихоб кунед',
  'All currencies': 'Ҳамаи асъорҳо',
  '4 somoni': '4 сомони',
  'Download extract': 'Зеркашӣ иқтибос',
  'Closed': 'Баста',
  'Loan amount': 'Маблағи қарз',
  'Loan start date': 'Оғози эътибор',
  'Loan end date': 'Санаи анҷом',
  'Loan balance': 'Бақияи қарз',
  'Loan Information': 'Маълумоти қарз',
  'Loan type': 'Намуди қарз',
  'Download payment schedule': 'Зеркашӣ ҷадвали пардохт',
  'Accredits': 'Аккредитив',
  'Overdraft': 'Овердрафт',
  'No loans': 'Қарз нест',
  'Next payment date': 'Санаи пардохти навбатӣ',
  'Amount due': 'Маблағи баргардонидани қарз',
  'Deposit owner': 'Соҳиби пасандоз',
  'Deposit Information': 'Маълумоти пасандоз',
  'Month': 'Моҳ',
  'Percent': 'Фоиз',
  'Loan requests': 'Дархостҳо барои қарз',
  'Submit request': 'Дархост фиристодан',
  'Loan term': 'Мӯҳлати қарз',
  'Purpose': 'Мақсади қарз',
  'No requests': 'Дархостҳо нестанд',
  'Request create title': 'Дархости онлайн барои маблағгузорӣ',
  'Request preview title': 'Пешнамоиши дархост пеш аз фиристодан',
  'Deal parameters': 'Параметрҳои муомила',
  'Applicant data': 'Маълумоти дархосткунанда',
  'Loan product type': 'Навъи маҳсулоти қарзӣ',
  'Financing amount': 'Маблағи маблағгузорӣ',
  'Desired term in months': 'Мӯҳлати дилхоҳ (бо моҳ)',
  'Financing purpose': 'Мақсади маблағгузорӣ',
  'Director full name': 'Насаб, ном ва номи падари директори генералӣ',
  'Generate preview': 'Барои пешнамоиш таҳия кардан',
  'Back to edit': 'Бозгашт (Таҳрир)',
  'Send request to bank': 'Дархостро ба бонк фиристодан',
  'Request submitted': 'Дархост бомуваффақият фиристода шуд!',
  'Request submitted desc':
    'Бонк дархости шуморо баррасӣ мекунад ва тавассути маълумоти зикршуда бо шумо тамос мегирад.',
  'Back to requests': 'Бозгашт ба дархостҳо',
  'Product type Loan': 'Қарз',
  'Additional documents': 'Замимаҳои иловагӣ',
  'Recommended documents list': 'Рӯйхати тавсияшавандаи файлҳо',
  'up to': 'то',
  'Select file': 'Файлро интихоб кунед',
  'Attached documents': 'Ҳуҷҷатҳои ба дархост замимашуда',
  'No documents attached': 'Замимаҳои иловагӣ бор карда нашуданд (танҳо дархости LOI)',
  'File is too large': 'Ҳаҷми файл аз ҳад зиёд аст',
  'MB': 'МБ',
  'Document bank form': 'Дархост аз рӯи шакли бонк',
  'Document balance': 'Баланси корхона',
  'Document passports': 'Шиносномаҳои роҳбарият',
  'Document contracts': 'Шартномаҳо',
  'Document feasibility study': 'Асосноккунии техникию иқтисодӣ (ТЭО)',
  'No deposits': 'Пасандоз нест',
  'Counterparties': 'Контрагенҳо',
  'Add': 'Илова кардан',
  'New counterparty': 'Контрагенти нав',
  'Foreigs': 'Шахсони хориҷӣ',
  'Residents': 'Резидентҳо',
  'Resident': 'Резидент',
  'Personal': 'Шахсӣ',
  'Public': 'Умумӣ',
  'templateType': 'Намуди намуна',
  'downloadTemplates': 'Зеркашӣ намудани намунаҳо',
  'today': 'Барои имрӯз',
  'for3days': 'Барои 3 рӯз',
  'forWeek': 'Барои як ҳафта',
  'forMonth': 'Барои як моҳ',
  'Select counterparty': 'Контрагент интихоб кунед',
  'Pick counterparty': 'Интихоби контрагент',
  'Download list': 'Зеркашӣ рӯйхати контрагенхо',
  'Yes': 'Бале',
  'No': 'Не',
  'Operation is not permitted': 'Иҷозат барои иҷрои амалиёт нест',
  'Own accounts payment shortname': 'Суратҳисобҳои худ',
  'Electric': 'Барқ',
  'Select region': 'Ноҳияро интихоб кунед',
  'Electricity payment': 'Пардохти барқ',
  'Personal account number': 'Рақами суратҳисоб',
  'Indication': 'Нишондиҳанда',
  'Select language': 'Забонро интихоб намоед',
  'Clean': 'Тоза кардан',
  'Download selected': 'Боргирии интихобшудаҳо',
  'Custom payments': 'Пардохтҳои гумрукӣ',
  'Payer': 'Пардохткунанда',
  'Account owner': 'Соҳиби суратҳисоб',
  'TinNotFoundInAsycuda': 'ИНН дар системаи АСИКУДА ёфт нашуд.',
  'Disposal': 'Утилизатсия',
  'Disposal payment': 'Пардохти утилизатсия',
  'Custom payment attention': 'Пардохтҳои гумрукӣ танҳо тавассути саҳифаи "Пардохтҳои гумрукӣ" пардохт карда мешавад.',
  'Leave a review': 'Шарҳи худро гузоред',
  'Username': 'Номи корбар',
  'Support service': 'Хадамоти дастгирӣ',
  'Write to chat': 'Дар чат навиштан',
  'Online support': 'Дастгирии онлайн',
  'Frequently asked questions': 'Саволҳои зуд-зуд додашаванда',
  'Your feedback helps us': 'Шарҳи шумо ба мо кӯмак мекунад',
  'Review': 'Шарҳ',
  'Suggestion': 'Пешниҳод',
  'Send': 'Ирсол кардан',
  'Thank you for your feedback': 'Аз фиристодани шарҳи шумо сипосгузорем',
  'Message': 'Паём',
  'Type of request': 'Навъи муроҷиат',
  'Security': 'Амният',
  'Quick navigation': 'Гузариши зуд',
  '2FA On': 'фаъол',
  '2FA Off': 'ғайрифаъол',
  'Phone label': 'Телефон',
  'Contact info': 'Маълумоти тамос',
  'Contact info desc': 'Телефон ва почта барои огоҳиномаҳо ва тасдиқҳо',
  'Change contact info': 'Тағйир додани маълумоти тамос',
  'Enter phone number': 'Рақами телефонро ворид намоед',
  'Enter email': 'Адреси почтаро ворид намоед',
  'Invalid email': 'Адреси почта нодуруст аст',
  'ConfirmContactInfoOtp': 'Барои тасдиқи тағйири маълумоти тамос ба шумо рамзи тасдиқ фиристода шуд',
  'Name label': 'Ном',
  'Payments nav desc': 'Пардохт эҷод кунед ва фиристед',
  'Statement nav desc': 'Иқтибос аз суратҳисоб',
  'Accounts nav desc': 'Ҳамаи суратҳисобҳои бонкӣ',
  'Transactions nav label': 'Таърихи амалиётҳо',
  'Transactions nav desc': 'Ҳамаи амалиётҳо',
  'Templates nav desc': 'Намунаҳои сабтшуда',
  'Enabled': 'Фаъол',
  'Disabled': 'Ғайрифаъол',
  'Connect Google Auth': 'Пайвасткунии Google Authenticator',
  'Scan QR code': 'QR-кодро дар барномаи Google Authenticator скан кунед',
  'After scan click enable': 'Пас аз скан кардан «Фаъол кардан»-ро пахш кунед',
  'Enable': 'Фаъол кардан',
  'Disable': 'Хомӯш кардан',
  'Disable 2FA title': 'Хомӯш кардани тасдиқи дуқадама',
  'Disable 2FA confirm':
    'Шумо мутмаин ҳастед, ки мехоҳед тасдиқи дуқадамаро хомӯш кунед? Ин ҳимояи ҳисоби шуморо кам мекунад.',
  'swiftAttention': {
    'title': 'Маълумоти муҳим',
    'dearClients': 'Муштариёни гиромӣ!',
    'payAttention':
      'Шуморо огаҳ месозем, ки бо мақсади пешгирии роҳ додани хатогиҳо дар супоришномаҳои пардохтӣ ва оқибатҳое, ки ин хатогиҳо ба вуҷуд оварда метавонанд, ҳангоми пур кардани супоришномаҳо ',
    'narrative': 'алалхусус дар банди таъиноти пардохтҳо бисёр бодиққат бошед',
    'file': 'Ва замима намудани ҳуҷҷатҳои тасдиқкунандаи онро аз хотир набароред',
  },
  'Footer': {
    'address':
      'Ҷумҳурии Тоҷикистон, ш. Душанбе, хиёбони Рӯдакӣ 95/1 Ҳ/М: 20402972413691, РМА: 020003038, РЯМ: 350101369',
    'emails': 'Почтаи электронӣ',
    'tj': 'Барои зангҳо дар дохили Тоҷикистон',
    'nbt': 'Телефони боварии Бонки миллии Тоҷикистон',
    'workTime': 'Вақти корӣ',
    'workDays': 'Рӯзҳои корӣ: душанбе - ҷумъа аз 08:00 то 17:00',
    'sunday': 'Якшанбе рузи истироҳат',
    'orb': 'ҶСК "Ориёнбонк"',
    'license': 'Иҷозатномаи БМТ таҳти №0000004 аз 30 январи соли 2014',
    'supportNumber': 'Хадамоти дастгирии Ориенбизнес',
    'dayOf': 'Шанбе ва Якшанбе рузҳои истироҳат',
  },
  'security': {
    'title': 'Бехатарии тиҷорати шумо: чи тавр ба фиреби қаллобон наафтед',
    'sectionPrefix': 'Қисми',
    'section1Title': 'Санҷиши асолати дархостҳо',
    'section1Subtitle': 'Қоидаҳои асосии бехатарии шумо ҳангоми муошират.',
    'section2Title': 'Бехатарии комплаенс-и тиҷорат',
    'section2Subtitle': 'Тавсияҳо оид ба ҳимояи ширкат аз баста шудани ҳисобҳо ва хатарҳои ҳуқуқӣ.',
    'labelAction': 'Амал',
    'labelConsequence': 'Оқибат',
    'labelRule': 'Қоида',
    'labelRisk': 'Хавф',
    'labelCheck': 'Нуқтаи назорат',
    's1i1Title': '«Супориши фаврии роҳбар»',
    's1i1Text':
      'Агар шумо дар мессенҷер ё тавассути суроғаи электронӣ аз номи роҳбар дархост гиред, ки дар он хоҳиши фавран гузаронидани пул ба реквизитҳои нав омадааст — ин боиси нигаронист. Қаллобон метавонанд тарзи муошират ва ҳатто садои роҳбарро тақлид кунанд.',
    's1i1Action': 'Ҳатман ба роҳбар тавассути телефони муқаррарӣ тамос гиред ва шахсан супоришро тасдиқ кунед.',
    's1i2Title': '«Дастгирии техникии сохта»',
    's1i2Text':
      'Зангҳо аз номи «кормандони бонк» бо хоҳиши насб кардани барномаҳои AnyDesk, RustDesk ё TeamViewer барои «созмондиҳии низом».',
    's1i2Action':
      'Дарҳол гӯшакро гузоред. Бонк ҳеҷ гоҳ насб кардани барномаҳои дастрасии дурро (удаленный доступ) талаб намекунад.',
    's1i3Title': 'Ивази рақам (Спуфинг)',
    's1i3Text':
      'Қаллобон аз технологияҳо истифода мебаранд, то дар экрани телефони мобилии шумо рақами расмии Бонк намоён шавад.',
    's1i3Action':
      'Агар аз шумо рамзҳои аз СМС воридшуда ё рамзҳоро талаб кунанд — алоқаро қатъ кунед ва худатон ба рақами бонк, ки дар сомонаи расмиаш нишон дода шудааст, тамос гиред.',
    's2i1Title': 'Хавфи «Транзит» (ПОД/ФТ)',
    's2i1Text':
      'Ба шумо пардохти «иштибоҳӣ» ворид мешавад ва аз шумо хоҳиш мекунанд, ки онро ба суратҳисоби дигар ё нақд баргардонед.',
    's2i1Consequence':
      'Шумо ба як ҳалқаи занҷири шустушӯи пул табдил меёбед, ки ин боиси баста шудани тамоми суратҳисобҳои ширкат мегардад.',
    's2i1Rule':
      'Маблағ бояд танҳо дар асоси мактуби расмӣ ва танҳо ба ҳамон суратҳисобе, ки аз он пул омадааст, баргардонида шавад.',
    's2i2Title': 'Домҳои таҳримӣ (Санксияҳо)',
    's2i2Text':
      'Тарафи муқобил нақшаҳои мураккаби пардохтро тавассути занҷираи миёнаравҳо ё ба суратҳисобҳои шахсони сеюм пешниҳод мекунад.',
    's2i2Risk':
      'Вайрон кардани таҳримҳои байналмилалӣ, ки метавонад бонк ва ширкати шуморо аз имконияти гузаронидани амалиётҳои асъорӣ маҳрум созад.',
    's2i3Title': 'Хизматрасониҳои қалбакӣ',
    's2i3Text':
      'Пардохт барои маркетинги қалбакӣ, консалтинг ё хизматрасониҳои IT ба ширкатҳое, ки корманд, офис ва таърихи фаъолият надоранд.',
    's2i3Check':
      'Бонк воқеияти фаъолиятро месанҷад. Кор бо ширкатҳои «холӣ» нишонаи берун баровардани маблағҳо (пулшӯӣ тавассути нақд) ҳисобида мешавад.',
    'alertTitle': 'Дар ҳолати қаллобӣ:',
    'alertStep1': 'Фавран интернетро дар компютер хомӯш намоед.',
    'alertStep2Prefix': 'Ба Бонк тавассути рақамҳои зерин тамос гиред:',
  },
  'interbankAttention': {
    'title': 'Диққат!',
    'intro': 'Ҳангоми пур кардани пардохтҳои андозӣ боварӣ ҳосил кунед, ки:',
    'item1': 'РМА-и пардохткунанда ва қабулкунанда дуруст нишон дода шудааст;',
    'item2': 'Кодҳои пардохт ба мақсади пардохт мувофиқат мекунанд;',
    'item3': 'Ҳамаи майдонҳои ҳатмӣ (аз ҷумла таснифи даромадҳо) пур карда шудаанд.',
    'footer': 'Хатоҳо метавонанд боиси рад шудани пардохт ё воридшавии нодурусти андозҳо гарданд.',
  },
};

export default translations;
